// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/goods-action/index.css
// module id = 1779
// module chunks = 153